<template>
    <div>
        <StatusBar background-color="#F3F4FB" @getHeight="getHeight" />
        <!--头部-->
        <template>
            <div class="header" :style="{top: height+'px'}">
                <div class="header-left" @click="goBack"><img src="@/assets/vipCoach/v2/icon_fh@2x.png" alt=""/></div>
                <div class="header-main">{{title}}</div>
                <div class="header-right">
                    <slot name="right" />
                </div>
            </div>
            <!--头部占位-->
            <div class="header-pre"></div>
        </template>
    </div>
</template>
<script>
import StatusBar from './statusbar.vue'
export default {
    name: 'vipCoachBar',
    components: {
        StatusBar
    },
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            height: ''
        }
    },
    methods: {
        goBack () {
            this.$emit('goBack')
        },
        getHeight (e) {
            this.height = e
        }
    }
}
</script>
<style lang="scss" scoped>
.header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    z-index: 10;
    align-items: center;
    height: 44px;
    background: #F3F4FB;

    .header-main {
        flex:1;
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        color: #333333;
    }

    .header-left {
        display: flex;
        padding:0 15px;
        font-size: 0;
        line-height: 1;
        img {
            width: 24px;
            height: 24px;
        }
    }
    .header-right{
        width: 54px;
    }
}
.header-pre {
    height: 44px;
}
</style>
